import React from 'react';

const posts = [
  {
    id: 1,
    title: 'JILL Project Findings',
    href: '#',
    description: 'A review of the honeypot research findings.',
    date: 'Dec 24th, 2022',
    datetime: '2022-12-24',
    category: { title: 'JILL Project', href: '#' },
    author: {
      name: 'Malachi S.',
      role: 'Founder',
      href: '#',
      imageUrl:
        'https://images.unsplash.com/photo-1502685104226-ee32379fefbe?auto=format&fit=facearea&facepad=3&w=144&h=144&q=80',
    },
  },
  // Add more posts as needed
];

export default function Blog() {
  return (
    <section className="py-16">
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl">
          Latest Innovation Articles
        </h2>
        <p className="mt-4 text-lg text-gray-600">
          Explore our recent insights on technology and innovation.
        </p>
      </div>

      <div className="mt-12 grid gap-8 max-w-lg mx-auto lg:grid-cols-3 lg:max-w-none">
        {posts.map((post) => (
          <div
            key={post.id}
            className="flex flex-col overflow-hidden rounded-lg shadow-lg bg-white hover:shadow-2xl transition-shadow duration-300"
          >
            <div className="flex-shrink-0">
              <img
                className="h-48 w-full object-cover"
                src="https://source.unsplash.com/random/800x600?technology"
                alt=""
              />
            </div>
            <div className="flex-1 p-6 flex flex-col justify-between">
              <div className="flex-1">
                <p className="text-sm font-medium text-indigo-600">
                  <a href={post.category.href} className="hover:underline">
                    {post.category.title}
                  </a>
                </p>
                <a href={post.href} className="block mt-2">
                  <h3 className="text-xl font-semibold text-gray-900">
                    {post.title}
                  </h3>
                  <p className="mt-3 text-base text-gray-500">
                    {post.description}
                  </p>
                </a>
              </div>
              <div className="mt-6 flex items-center">
                <div className="flex-shrink-0">
                  <a href={post.author.href}>
                    <span className="sr-only">{post.author.name}</span>
                    <img
                      className="h-10 w-10 rounded-full"
                      src={post.author.imageUrl}
                      alt={post.author.name}
                    />
                  </a>
                </div>
                <div className="ml-3">
                  <p className="text-sm font-medium text-gray-900">
                    <a href={post.author.href} className="hover:underline">
                      {post.author.name}
                    </a>
                  </p>
                  <div className="flex space-x-1 text-sm text-gray-500">
                    <time dateTime={post.datetime}>{post.date}</time>
                    <span aria-hidden="true">&middot;</span>
                    <span>{post.author.role}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
